<template>
  <div class="view-account container">
    <h3 class="font-weight-bold">Minha conta</h3>

    <image-input
      @pick="pickFile"
      :url="avatar"
      :loading="loadingAvatar"
      class="mb-4"
    />

    <form class="mb-5" @submit.prevent="submit">
      <form-group
        id="name"
        v-model="form.name"
        :errors="errors.name"
        type="text"
        label="Nome"
        placeholder="Seu nome"
      />

      <form-group
        id="email"
        v-model="form.email"
        :errors="errors.email"
        type="email"
        label="Email"
        placeholder="Seu e-mail"
        readonly
      />

      <form-group
        id="phone"
        v-model="form.phone"
        :errors="errors.phone"
        type="text"
        label="Número de celular"
        mask="(##) #####-####"
      />

      <form-group
        id="discord_username"
        v-model="form.discord_username"
        :errors="errors.discord_username"
        type="text"
        label="Username no Discord"
      />

      <button
        type="submit"
        class="btn btn-primary btn-block px-5"
        :disabled="loading"
      >
        <loading :show="loading">Salvar</loading>
      </button>
    </form>

    <change-password />
  </div>
</template>

<script>
import { formFields } from "@/functions/helpers.js";
import ChangePassword from "@/components/account/ChangePassword";

export default {
  components: { ChangePassword },
  data() {
    return {
      loading: false,
      loadingAvatar: false,
      avatar: this.$user.user.avatar,
      ...formFields(["name", "phone", "email", "discord_username"], {
        ...this.$user.user
      })
    };
  },
  methods: {
    pickFile(file) {
      if (this.loadingAvatar) {
        return;
      }
      this.loadingAvatar = true;
      this.$store
        .dispatch("user/update", { avatar: file })
        .then(() => {
          this.$message.success("Salvo com sucesso");
          this.avatar = file;
        })
        .catch(error => {
          this.$message.error(error.non_field_errors[0] || "Erro ao salvar");
        })
        .finally(() => {
          this.loadingAvatar = false;
        });
    },
    submit() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      this.$store
        .dispatch("user/update", this.form)
        .then(() => {
          this.$message.success("Salvo com sucesso");
        })
        .catch(error => {
          this.errors = error.response.data;
          if (this.errors.non_field_errors) {
            this.$message.error(this.errors.non_field_errors[0]);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss">
.view-account {
  margin-top: 13vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 364px;

  h4 {
    margin-bottom: 8px;
  }

  hr {
    border-color: white;
    margin: 0 0 24px;
  }

  form {
    width: 364px;
  }

  .form-control {
    border-radius: 8px;
    height: 48px;
    border: 1px solid #9a9a9a;
    background-color: transparent;
    color: white;
    &::placeholder {
      color: #9a9a9a;
    }
  }
}
</style>
